<template>

<div class="container-fluid">
	<toolbar v-if="!$store.printMode">
		<router-link to="/time-logs/history" class="btn btn-link">
			<i class="fa fa-caret-left fa-2x"></i>
			<h2>Submitted Logs</h2>
		</router-link>

		<div class="controls">
			<nav-tabs :tabs="tabs" :active-index="tabActiveIndex" v-on:tabClick="tabClick"></nav-tabs>
		</div>
	</toolbar>

	<collapsible-panel :external-toggle="showFilters" v-on:panelRetract="showFilters = false" panel-size="md">
		<template slot="panel">
			<field label="Compensation Group/Union" 
				col-class="stacked" 
				:params="{type:'select-multi',options:unionOptions}"
				v-on:change="selectedUnionsChange"
				v-model="selectedUnions">
			</field>

			<field label="Jump to Employee" 
				col-class="stacked" 
				:params="{type:'select',options:employeeOptions}" 
				v-model="selectedEmployeeId"
				v-on:change="jumpToEmployee">
			</field>

			<h4 class="mt-3">Report Display</h4>

			<field label="Job Column"
				col-class="col-9"
				:control-left="true"
				:params="{type:'boolean'}"
				v-model="$store.timeLogSettings.report_display_job"
				v-on:change="saveDisplaySetting('report_display_job',$event)">
			</field>

			<field label="Customer Column"
				col-class="col-9"
				:control-left="true"
				:params="{type:'boolean'}"
				v-model="$store.timeLogSettings.report_display_customer"
				v-on:change="saveDisplaySetting('report_display_customer',$event)">
			</field>

			<field label="Rate Column"
				col-class="col-9"
				:control-left="true"
				:params="{type:'boolean'}"
				v-model="$store.timeLogSettings.report_display_rate"
				v-on:change="saveDisplaySetting('report_display_rate',$event)">
			</field>

			<field label="Pay Adjustments Column"
				col-class="col-9"
				:control-left="true"
				:params="{type:'boolean'}"
				v-model="$store.timeLogSettings.report_display_payboosts"
				v-on:change="saveDisplaySetting('report_display_payboosts',$event)">
			</field>

			<field label="Total Column"
				col-class="col-9"
				:control-left="true"
				:params="{type:'boolean'}"
				v-model="$store.timeLogSettings.report_display_total"
				v-on:change="saveDisplaySetting('report_display_total',$event)">
			</field>

		</template>
		<template slot="main">

			<button v-if="$store.printMode" class="btn btn-light btn-sm print-mode-button" style="position: fixed;top: 0;right: 0;" v-on:click="$store.printMode = false">
				<i class="fa fa-times"></i>
				Exit Print Mode
			</button>

			<div class="float-right" v-else>

				<context-menu 
					:menu-items="[
						{text: 'Filter',                                        icon:'fa-filter',     clickFunction:'toggleFilter'},
						{text: 'Regenerate Pay Period',                         icon:'fa-sync',       clickFunction:'confirmRegeneratePayPeriod'},
						{text: 'Mark as Processed',                             icon:'fa-check',      clickFunction:'processPeriodAndLogs'},
						{text: 'Export as CSV (by Employee)',                   icon:'fa-file-csv',   clickFunction:'employeePeriodCSV'},
						{text: 'Export as CSV (by Project/Service)',            icon:'fa-file-csv',   clickFunction:'jobPeriodCSV'},
						{text: 'Export as CSV (by Employee & Project/Service)', icon:'fa-file-csv',   clickFunction:'employeeJobPeriodCSV'},
						{text: 'Print Report',                                  icon:'fa-print',      clickFunction:'printReport'},
						{text: 'Delete',                                        icon:'fa-trash',      clickFunction:'deletePeriod',itemClass:'text-danger'}
					]"
					width="400px"
					v-on:toggleFilter="toggleFilter"
					v-on:confirmRegeneratePayPeriod="confirmRegeneratePayPeriod"
					v-on:processPeriodAndLogs="processPeriodAndLogs"
					v-on:employeePeriodCSV="periodCSV('user')"
					v-on:jobPeriodCSV="periodCSV('job')"
					v-on:employeeJobPeriodCSV="periodCSV('user-job')"
					v-on:printReport="printReport"
					v-on:deletePeriod="deletePeriodModalVisible = true">		
				</context-menu>

			</div>
			

			<h2 v-if="Object.keys(period).length > 0">{{ moment(period.start).format("MMM D") }} to {{ moment(period.end).format("MMM D YYYY") }}</h2>
			<div style="clear: both;"></div>

			<div v-if="period.generation_completed_at == '0000-00-00 00:00:00' && period.generation_completed_at != null" class="text-danger">
				<h4 class="text-danger">
					<i class="fa fa-hourglass"></i>
					Generation in Progress...
				</h4>
				<p>This report is currently being generated, it may appear incomplete</p>
			</div>

			<hr v-if="!totalsPage">

			<div class="alert alert-warning" v-if="period.processed == 1">
				<div class="d-flex flex-row justify-content-between">
					<div>This pay period has been processed</div>
					<button class="btn btn-light" v-on:click="processPeriod(0)">
						<i class="fa fa-check"></i>
						Mark as un-Processed
					</button>
				</div>
			</div>

			<div v-if="!$store.printMode && !totalsPage" class="d-flex flex-row justify-content-between mb-2">

				<div>
					<button v-if="selectedEmployeeIndex > 1" class="btn btn-light" v-on:click="previousEmployee">
						<i class="fa fa-chevron-left"></i>
						Previous Employee
					</button>
				</div>

				<div v-if="!totalsPage">
					<button v-if="selectedEmployeeIndex < users.length" class="btn btn-light" v-on:click="nextEmployee">
						Next Employee
						<i class="fa fa-chevron-right"></i>
					</button>
				</div>
				
			</div>

			<template v-if="!totalsPage">
				<div style="overflow-x: auto;" >
					
					<table v-if="!$store.printMode" class="table table-sm user-table">
						<period-report-user 
							v-for="userReport in filteredReports"
							:key="userReport.id"
							:colspan="colspan"
							:period-days="periodDays"
							:user-note-toggle="userNoteToggle[userReport.id]"
							:user-note="userNotes[userReport.user_id]"
							:user-report="userReport"
							:working="working"
							:user="getReportUser(userReport)"
							v-on:saveNote="saveNote"
							v-on:toggleNote="toggleNote"
							v-on:viewDayLogs="viewDayLogs($event,userReport)">
						</period-report-user>

					</table>
					<table v-else v-for="userReport in filteredReports" class="table table-sm user-table" style="page-break-after: always;">
						<period-report-user 
							:key="userReport.id"
							:colspan="colspan"
							:period-days="periodDays"
							:user-note-toggle="userNoteToggle[userReport.id]"
							:user-note="userNotes[userReport.user_id]"
							:user-report="userReport"
							:working="working"
							:user="getReportUser(userReport)"
							v-on:saveNote="saveNote"
							v-on:toggleNote="toggleNote"
							v-on:viewDayLogs="viewDayLogs($event,userReport)">
						</period-report-user>
					</table>
				</div>

				<div class="d-flex flex-row justify-content-between">

					<div>
						<button v-if="selectedEmployeeIndex > 1" class="btn btn-light" v-on:click="previousEmployee">
							<i class="fa fa-chevron-left"></i>
							Previous Employee
						</button>
					</div>

					<div v-if="!totalsPage">
						<button v-if="selectedEmployeeIndex < users.length" class="btn btn-light" v-on:click="nextEmployee">
							Next Employee
							<i class="fa fa-chevron-right"></i>
						</button>
					</div>
				</div>
			</template>

			<table v-else-if="totalsPage" class="table table-sm user-table">
				<tbody>
					<tr>
						<th>Employee</th>
						<th>Notes</th>
						<th>Rate Totals</th>
						<th class="right">Per Diem Total</th>
						<th class="right">Mileage Total</th>
					</tr>
					<tr v-for="report in filteredReports">
						<td>{{ report.fullName }}</td>
						<td>{{ userNotes[report.user_id] }}</td>
						<td>
							<ul>
								<template v-for="(ca,key) in report.caTotals" >
									<li v-for="(typeTotal,label) in ca" v-if="label != 'color'" :style="{color:ca.color}">

										<strong>{{label}}:</strong> {{typeTotal.toFixed(2)}}
									</li>
								</template>
							</ul>
						</td>
						<td class="right">{{report.totalPerDiemPay > 0 ? '$' : ''}} {{ report.totalPerDiemPay }}</td>
						<td class="right">{{report.totalMileagePay > 0 ? '$' : ''}} {{ report.totalMileagePay }}</td>
					</tr>
				</tbody>
			</table>
		</template>
	</collapsible-panel>

	<modal-dialog
		:modal-visible="regenerateConfirmDialogVisible"
		title="Regenerate Pay Period"
		confirm-button-text="Yes, Regenerate"
		:working="regenerateWorking"
		v-on:closeModal="regenerateConfirmDialogVisible = false"
		v-on:confirm="regeneratePayPeriod">

		<div v-if="regenerateWorking" class="text-center">
			<i class="fa fa-sync fa-spin fa-3x"></i>
			<div>
				Regenerating report. This may take a few minutes
			</div>
		</div>
		<div v-else>
			Do you want to regenerate the Pay Period? This will overwrite the current pay period records with a fresh snapshot of the Time Logs
		</div>
	</modal-dialog>

	<modal-dialog
		:modal-visible="deletePeriodModalVisible"
		title="Delete Pay Period"
		confirm-button-text="Yes, Delete"
		button-class="btn-outline-danger"
		v-on:closeModal="deletePeriodModalVisible = false"
		v-on:confirm="confirmDeletePeriod">

		Are you sure you want to delete this Pay Period Report? (it can be regenerated if necessary)

	</modal-dialog>

	<modal-dialog
		:modal-visible="dayLogListModal.visible"
		:title="dayLogListModal.title"
		:submit-visible="false"
		:working="dayLogListModal.working"
		modal-size="modal-lg"
		cancel-button-text="Done"
		v-on:closeModal="dayLogListModal.visible = false">

		<table-list
			record-name="Time Log"
			:fields="dayLogListModal.fields"
			:records="dayLogListModal.logs"
			:hide-record-count="true"
			:has-edit="true"
			v-on:edit="editTimeLog">
		</table-list>

	</modal-dialog>

	<time-log-edit-modal 
		v-if="'id' in dayLogListModal.editLog"
		:visible="dayLogListModal.editModalVisible"
		:record="dayLogListModal.editLog"
		:show-skip-mileage-per-diem="true"
		v-on:closeModal="dayLogListModal.editModalVisible = false"
		v-on:save="saveDayLogTimeLog">
	</time-log-edit-modal>

</div>

</template>

<script>
import Toolbar from "@/layout_fragments/Toolbar"
import NavTabs from "@/layout_fragments/NavTabs"

import Field from "@/components/Field"
import ModalDialog from "@/components/ModalDialog"
import InfoBox from "@/components/InfoBox"
import TableList from "@/components/TableList"
import TimeLogEditModal from "@/components/super_components/TimeLogEditModal"

import Chart from '@/components/Chart'
import PeriodReportUser from "./PeriodReportUser"
import ContextMenu from "@/layout_fragments/ContextMenu" 
import CollapsiblePanel from "@/layout_fragments/CollapsiblePanel"

import TimeLogMixins from "@/mixins/TimeLogMixins"

export default {

	name: 'TimeLogsPeriod',
	components: {
		Toolbar,
		Field,
		ModalDialog,
		InfoBox,
		Chart,
		NavTabs,
		PeriodReportUser,
		TableList,
		TimeLogEditModal,
		ContextMenu,
		CollapsiblePanel
	},
	mixins: [TimeLogMixins],
	data() {
		return {
			period: {},
			users: [],
			payPeriodUserReports: [],
			briefPayPeriodUserReports: [],
			userReports: [],
			userNotes: {},
			unionsWithLogs: [],
			selectedEmployeeIndex: 0,
			selectedEmployeeId: 0,
			selectedUnions: ['all'],
			totalsPage: false,
			regenerateConfirmDialogVisible: false,
			regenerateWorking: false,
			tabs: [
				{
					label: "Detailed View",
					icon: "fa-table",
					click: "detailed"
				},
				{
					label: "Summary View",
					icon: "fa-calculator",
					click: "summary"
				}
			],
			tabActiveIndex: 0,
			deletePeriodModalVisible: false,
			dayLogListModal: {
				visible: false,
				title: "Logs for...",
				logs: [],
				fields: [
					{label: 'Time In',key:'timeIn'},
					{label: "Regular Hours",key:'regular_hours'},
					{label: "OT 1.5x",key:'overtime_hours_15x'},
					{label: "OT 2x",key:'overtime_hours_2x'},
					{label: "OT 2.5x",key:'overtime_hours_25x'},
				],
				editModalVisible: false,
				editLog: {},
				job: {},
				working: false
			},
			showFilters: true,
			working: false

		}
	},
	computed: {
		chartHeight() {
			let height

			if (window.innerWidth < 500) 
				height = (Object.keys(this.chartLabels).length * 30) + 50
			
			else
				height = (Object.keys(this.chartLabels).length * 20) + 50

			return height
		},
		colspan() {
			let optionalColumns = 0
			if ("report_display_rate" in this.$store.timeLogSettings)
				optionalColumns += +this.$store.timeLogSettings.report_display_rate

			if ("report_display_payboosts" in this.$store.timeLogSettings)
				optionalColumns += +this.$store.timeLogSettings.report_display_payboosts
			
			if ("report_display_job" in this.$store.timeLogSettings && this.$store.timeLogSettings.report_display_job == 1 || "report_display_customer" in this.$store.timeLogSettings && this.$store.timeLogSettings.report_display_customer == 1)
				optionalColumns++

			if ("report_display_total" in this.$store.timeLogSettings && this.$store.timeLogSettings.report_display_total == 1)
				optionalColumns++

			return this.periodDays.length + optionalColumns
		},
		filteredReports() {
			let vm = this

			let reports = this.userReports.filter((report,index) => {
				let include = true

				if ((vm.selectedEmployeeId != "all" && vm.selectedEmployeeId != report.id && vm.selectedEmployeeId) || ('is_salary' in report && report.is_salary == 1))
					include = false

				if (!report.id)
					return false

				return include
			})

			//filter by union
			if (vm.selectedUnions && !vm.selectedUnions.find(option => option == 'all') && (vm.selectedEmployeeId == 'all' || !vm.selectedEmployeeId)) {

				reports = reports.filter(report => {

					//see if report has union in selected unions list
					let include = false

					report.unionIds.forEach(id => {
						if (vm.selectedUnions.find(option => option == id))
							include = true
					})

					//if non-unionized is selected, report.unionIds could be either blank, or have '0' within it
					if (vm.selectedUnions.indexOf(0) >= 0 || vm.selectedUnions.indexOf('all') >= 0) {
						if (report.unionIds.indexOf(0) >= 0 || report.unionIds.length == 0)
							include = true
					}

					return include
				})
			}

			if (reports.length > 1) {
				reports.sort((a,b) => {
					if (a.fullName > b.fullName)
						return 1
					else 
						return -1
				})
			}

			return reports

		},
		periodDays() {
			let days = []

			let start = this.moment(this.period.start)
			let end = this.moment(this.period.end).add(1,"days")

			let d = start
			while (d < end) {

				days.push(this.moment(d))

				d = new Date(start.add(1,"days"))
			}

			return days
		},
		chartLabels() {
			let vm = this

			let labels = Object.keys(this.totalHrsByDay)

			labels.sort()

			labels = labels.map(d => {
				return vm.moment(d).format("dd MMM D")
			})

			return labels
		},
		chartValues() {
			let values = []

			let vm = this

			let days = Object.keys(this.totalHrsByDay)

			days.sort()

			days.forEach(key => {
				values.push(this.totalHrsByDay[key])
			})

			return values
		},
		employeeOptions() {
			let vm = this

			//filter out employees with no logs
			let users = this.users
			if (vm.selectedUnions && vm.selectedUnions.indexOf('all') == -1) {

				users = this.users.filter(user => {

					let reportRecord = this.briefPayPeriodUserReports.find(userRecord => userRecord.user_id == user.id)
					
					if (reportRecord) {
						let unionIds = []
						try {
							unionIds = JSON.parse(reportRecord.user_union_ids_json)
						}
						catch (e) {}

						let include = false
						unionIds.forEach(id => {
							if (vm.selectedUnions.find(option => option == id))
								include = true
						})

						if (!include && unionIds.length == 0 && vm.selectedUnions.indexOf(0) >= 0)
							include = true

						return include
					}
					
					return false
				})
			}

			let options = this.optionify(users.map(user => {

				user.fullName = user.first_name+ " "+ user.last_name

				return user

			}),"fullName").sort((a,b) => {
				let nameA = a.text.toUpperCase()
				let nameB = b.text.toUpperCase()

				if (nameA < nameB) return -1
				else return 1
			})

			options.unshift({
				text: "All",
				value: "all"
			})

			return options
		},
		unionOptions() {
			let unions = this.optionify(this.$store.unions,"union_name")

			unions.unshift({value: 0,text:'Non-Unionized'})
			unions.unshift({value:'all',text:"All"})

			return unions
		}
	},
	methods: {
		getReportUser(report) {
			if (this.users && 'user_id' in report && report.user_id) {
				const user = this.users.find(user => user.id == report.user_id)
				if (user)
					return user
			}
			return false
		},
		periodCSV(mode='user') {
			let url = window.apiBase + "PayPeriod/summary?format=csv&token="+this.$store.sessionToken+"&period_id="+this.period.id+"&mode="+mode
			window.open(url, '_blank')
		},
		setEmployeeIndex(index) {
			let vm = this

			let userOption = this.employeeOptions[index]
			vm.selectedEmployeeIndex = index

			if (userOption) {

				vm.selectedEmployeeId = userOption.value

				let report = vm.userReports.find(report => report.user_id == userOption.value)

				return new Promise((resolve,reject) => {
					if (!report) {

						let params = {
							filters: [
								['user_id',userOption.value],
								['period_id',vm.period.id]
							]
						}

						vm.spinner(true)

						vm.getJSON("PayPeriodUserReport/get",params).then(response => {
							vm.spinner(false)

							vm.payPeriodUserReports = response.data

							let parsedReport = {}
							try {
								parsedReport = JSON.parse(response.data[0].report_json)
							}
							catch (e) {}

							let mutatedReport = vm.mutateReport(parsedReport,response.data[0])

							//check that report isn't already pushed
							if (!vm.userReports.find(theReport => theReport.id == mutatedReport.id)) {
								vm.userReports.push(mutatedReport)

								vm.userNotes[response.data[0].user_id] = response.data[0].notes
							}
							

							resolve(true)
						})
					}
					else {
						
						resolve(true)
					}
				})
			}
		},
		nextEmployee() {
			let vm = this
			this.totalsPage = false
			this.setEmployeeIndex(this.selectedEmployeeIndex+1)
		},
		previousEmployee() {
			let vm = this
			this.totalsPage = false
			this.setEmployeeIndex(this.selectedEmployeeIndex-1)
		},
		jumpToEmployee(userId) {
			let vm = this

			if ((!userId && this.totalsPage) || userId == 'all') {
				this.fetchAllUserReports()
			}
			else {
				let index = this.employeeOptions.findIndex(user => user.value == userId)
				this.setEmployeeIndex(index)
			}
		},
		toggleFilter() {
			this.showFilters = !this.showFilters
		},
		printReport() {
			this.$store.printMode = true
			this.showFilters = false
			//this.selectedEmployeeIndex = 'all'
			this.$nextTick(() => {
				window.print()
			})
		},
		tabClick(clickAction) {
			if (clickAction == "detailed") {
				this.totalsPage = false
				this.tabActiveIndex = 0
			}
			else {
				this.totalsPage = true
				this.tabActiveIndex = 1

				if (this.userReports.length < this.users.length && !this.selectedEmployeeIndex)
					this.fetchAllUserReports()
			}

			window.history.pushState({},"","/time-logs/submitted/"+this.$route.params.period_slug+"/"+clickAction)
		},
		selectedUnionsChange(value) {
			let vm = this

			let oldList = this.cloneObj(this.selectedUnions)

			//do not let 'all' selection co-exist with other options
			this.$nextTick(() => {
				let allIndexNewList = value.findIndex(option => option == 'all')

				if (value.length == 0)
					vm.selectedUnions = ["all"]
				else if (value[value.length - 1] != 'all' && allIndexNewList >= 0) 
					vm.selectedUnions.splice(allIndexNewList,1)
				else {
					let allIndexOldList = oldList.findIndex(option => option == 'all')

					if (allIndexNewList >= 0 && allIndexOldList == -1)
						vm.selectedUnions = ["all"]
				}

			})
		},
		processPeriodAndLogs() {
			this.processPeriod(1)
		},
		processPeriod(state) {
			let vm = this

			let promises = [
				this.postData("PayPeriod/save",{id:this.period.id,processed: state})
			]

			if (state == 1) {
				//compile list of logs to mark as processed
				let periodObj = {}
				try {
					periodObj = JSON.parse(this.period.period_json)
				}
				catch (ex) {}

				let logsPayload = []

				let now = this.moment().utc().format("YYYY-MM-DD HH:mm:ss")

				periodObj.users.forEach(user => {
					user.logs.forEach(log => {
						logsPayload.push({
							id: log.id,
							processed_at: now
						})
					})
				})

				promises.push(this.postData("TimeLog/save-batch",{records: JSON.stringify(logsPayload)}))
			}

			Promise.all(promises).then(responses => {
				vm.period.processed = state
			})
		},
		confirmRegeneratePayPeriod() {
			this.regenerateConfirmDialogVisible = true
		},
		regeneratePayPeriod() {
			let vm = this

			vm.regenerateWorking = true

			this.postData("PayPeriod/save",{period_start: vm.period.start},true).then(response => {
				vm.regenerateWorking = false

				vm.fetchData()
				vm.regenerateConfirmDialogVisible = false
			})
		},
		viewDayLogs(details,user) {
			let vm = this

			this.dayLogListModal.visible = true
			this.dayLogListModal.title = details.rateLabel+" Time Logs for "+user.fullName+ " on "+this.formatDate(details.date)

			this.dayLogListModal.logs = user.logs.filter(log => vm.moment.utc(log.time_in).local().format("YYYY-MM-DD") == details.date).map(log => {
				log.timeIn = vm.formatDateTimeToLocal(log.time_in)

				return log
			})
		},
		editTimeLog(log) {
			this.dayLogListModal.editLog = log
			this.dayLogListModal.editModalVisible = true

			//get job
			if (log.Job)
				this.dayLogListModal.job = log.Job
			else if (log.Service)
				this.dayLogListModal.job = log.Service

		},
		saveDayLogTimeLog(payload) {
			let vm = this

			this.dayLogListModal.working = true

			this.postData("TimeLog/save",payload,true).then(response => {
				if (response.success) {
					vm.alertInfo("Changes to time log saved. Regenerating report...")
					//regenerate user's report
					let periodPayload = {
						user_id: payload.user_id,
						period_id: vm.period.id
					}
					vm.postData("PayPeriodUserReport/save",periodPayload).then(saveResponse => {
						vm.alertInfo("Report regenerated, fetching fresh report...")
						//pull the fresh report now
						let params = {
							filters: [
								["period_id",vm.period.id],
								["user_id",payload.user_id]
							]
						}
						vm.getJSON("PayPeriodUserReport/get",params).then(reportResponse => {
							//replace userReport with fresh pulle one
							vm.alertSuccess("Done")
							vm.dayLogListModal.editModalVisible = false
							vm.dayLogListModal.working = false
							vm.dayLogListModal.visible = false

							let reportIndex = vm.userReports.findIndex(report => report.id == payload.user_id)

							if (reportIndex >= 0) {
								let reportObj = {}
								try {
									reportObj = JSON.parse(reportResponse.data[0].report_json)
								}
								catch (e) {}
								vm.userReports.splice(reportIndex,1,vm.mutateReport(reportObj,reportResponse.data))
							}
						})
						
					})

					//vm.alertSaved("Changes to time log saved. The changes will not reflect on the report until it is regenerated.")
					//vm.dayLogListModal.editModalVisible = false
				}
			})
		},
		toggleNote(user_id) {

			if (this.userNoteToggle[user_id])
				this.userNoteToggle[user_id] = false
			else
				this.userNoteToggle[user_id] = true

			this.$forceUpdate()
		},
		saveNote(user_id,noteText) {
			let vm = this

			let payload = {
				user_id: user_id,
				period_id: this.period.id,
				notes: noteText,
				regenerate: false
			}

			this.postData("PayPeriodUserReport/save",payload).then(response => {
				if (response.success)
					vm.alertSaved("Notes saved")

			})
		},
		confirmDeletePeriod() {
			let vm = this

			this.postData("PayPeriod/delete",{id: this.period.id},true).then(response => {
				if (response.success) {
					vm.alertSuccess("Pay period deleted")
					vm.$router.push("/time-logs/history")
				}
			})
		},
		saveDisplaySetting(key,value) {
			let vm = this
			let booleanValue = value ? 1 : 0

			let payload = {
				id: this.$store.timeLogSettings.id
			}
			payload[key] = booleanValue

			this.postData("TimeLogSetting/save",payload).then(response => {
				vm.$forceUpdate()
			})
		},
		mutateEmployees() {
/**
*
[
	{
		id: 1,
		fullName: 'Chad Tiffin',
		classification: obj,
		userTotal: float,
		dailyTotals: {},
		typeTotals: {},
		caTotals: {},
		grandTotal: float,
		totalMileageKm: float,
		totalPerDiemPay: float,
		totalMileagePay: float,
		payrollLines: [
			{
				classification: string,
				pay_boosts: array of ints,
				payboosts_label: string,
				job_name: '',
				job_num,
				job_id: (int),
				job_slug: hash,
				jobType: Job/Service
				hr_type: reg/1.5x/2x/2.5x,
				lineTotal: float,
				collectiveAgreeementId: (int),
				textColor: hexCode,
				days: {
					CURRENT 'YYYY-MM-DD': hrs
					TO-DO 'YYYY-MM-DD': {hrs: hrs, processed: true/false}
				}
				
			}
		],
		mileage: [
			{
				day: 'YYYY-MM-DD',
				job_name: string,
				job_num: string,
				job_id: int
				per_diem: {dollar amount},
				collectiveAgreement: (string),
				collectiveAgreeementId: (int),
				distance: {km},
				mileage_pay: {dollar amount}
			}
		]
	}
]
**/			
			let vm = this

			let periodObj = JSON.parse(vm.period.period_json)

			let hrTypes = ["regular_hours","overtime_hours_15x","overtime_hours_2x","overtime_hours_25x"]

			periodObj.users.map(user => {

				let collectiveAgreements = JSON.parse(JSON.stringify(vm.collectiveAgreements))
				let dailyTotals = {}
				let grandTotal = 0
				let caTotals = {}
				let totalMileagePay = 0
				let totalMileageKm = 0
				let totalPerDiemPay = 0

				if (!("typeTotals" in user))
					user.typeTotals = {}

				vm.userNoteToggle[user.id] = false
				vm.userNotes[user.id] = ""

				let payrollLines = []
				let mileage = []

				user.logs.forEach(log => {

					let logDate = vm.moment.utc(log.time_in).local().format("YYYY-MM-DD")	

					let job_id, job_name, job_num
					if ("Job" in log && log.Job) {
						job_id = log.Job.id
						job_name = log.Job.job_name
						job_num = log.Job.job_num
					}
					else if ("Service" in log && log.Service) {
						job_id = log.Service.id
						job_name = log.Service.job_name

						let internalWO = ""
						if (log.Service.internal_wo)
							internalWO = ": WO #"+log.Service.internal_wo

						job_num = log.Service.job_num+internalWO
					}

					let mileageAdded = false

					hrTypes.forEach((type,index) => {

						//make sure there is actually hours logged for this type
						if (log[type] > 0) {

							grandTotal += parseFloat(log[type])

							if (!(logDate in vm.totalHrsByDay))
								vm.$set(vm.totalHrsByDay,logDate,0)

							vm.totalHrsByDay[logDate] += parseFloat(log[type])

							//search payroll line for matching type, job, day & payBoost (if applicable)
							let lineFound = false
							let lineTotal = 0

							if (log[type] > 0 && logDate in dailyTotals)
								dailyTotals[logDate] += parseFloat(log[type])
							else
								dailyTotals[logDate] = parseFloat(log[type])

							let log_ca_id
							//this is where the new format of CA's should be set (with multiple CA's per job)
							if ("collective_agreement_id" in log)
								log_ca_id = log.collective_agreement_id

							let caName
							if (log_ca_id == 0 || !log_ca_id)
								caName = "Non-Union"
							else
								//set Compensation Schedule name
								caName = collectiveAgreements.find(ca => log_ca_id == ca.id).title

							if (!(caName in caTotals))
								caTotals[caName] = {}

							payrollLines.forEach(prLine => {

								let payBoostMatchesOrNotApplicable = true

								let payBoostLabel = ""

								if ("PayBoost" in log && log.PayBoost.length > 0) {
									//payboosts need to be searched to make sure the list matches the log's list, otherwise it belongs on a new prline

									log.PayBoost.forEach(pb => {
										if (prLine.pay_boosts.indexOf(pb.id) == -1)
											//not found
											payBoostMatchesOrNotApplicable = false
										else
											payBoostLabel += pb.description + " "
									})
								}

								if (payBoostMatchesOrNotApplicable && log.classification == prLine.classification) {
									if ((prLine.job_id == log.job_id || prLine.job_id == log.service_id) && type == prLine.hr_type) {
										lineFound = true

										if (prLine.days[logDate])
											prLine.days[logDate] += parseFloat(log[type]) //add to hrs for day
										else
											prLine.days[logDate] = parseFloat(log[type]) //add to hrs for day

										for (var day in prLine.days) 
											lineTotal += parseFloat(prLine.days[day])

										prLine.lineTotal = lineTotal

										let logTypeLabel = vm.logTypeToLabel(type,log.PayBoost,caName,log)

										if (!(logTypeLabel in user.typeTotals))
											user.typeTotals[logTypeLabel] = 0

										if (!(logTypeLabel in caTotals[caName]))
											caTotals[caName][logTypeLabel] = 0

										caTotals[caName][logTypeLabel] += parseFloat(log[type])

										user.typeTotals[logTypeLabel] += parseFloat(log[type])

									}
								}

							})
							if (!lineFound) {

								let logTypeLabel = vm.logTypeToLabel(type,log.PayBoost,caName,log)

								let hourlyRate = 0

								//line doesn't exist, so we need to add another one
								let newPayrollLine = vm.addPayrollLine(log,type, caName, log_ca_id,logTypeLabel,hourlyRate)

								if (!(logTypeLabel in user.typeTotals))
									user.typeTotals[logTypeLabel] = 0

								if (!(logTypeLabel in caTotals[caName]))
									caTotals[caName][logTypeLabel] = 0

								caTotals[caName][logTypeLabel] += parseFloat(log[type])

								user.typeTotals[logTypeLabel] += parseFloat(log[type])

								payrollLines.push(newPayrollLine)
							}

							//if mileage, push it, only on first index though because we don't want a mileage entry for each hour type!
							//also only one mileage log per project per day
							if (!mileageAdded && (log.per_diem > 0 || log.mileage_pay > 0)) {

								let logDate = vm.moment.utc(log.time_in).local().format("YYYY-MM-DD")

								let mileageExistsAlready = mileage.find(record => record.day == logDate && record.job_id == job_id)

								if (!mileageExistsAlready) {
									mileageAdded = true;
							
									let per_diem = ""
									if (!isNaN(log.per_diem) && log.per_diem != "" && parseFloat(log.per_diem) > 0 && log.skip_perdiem != 1)
										per_diem = parseFloat(log.per_diem).toFixed(2)

									totalPerDiemPay += parseFloat(log.per_diem)
									totalMileagePay += parseFloat(log.mileage_pay)
									totalMileageKm += parseFloat(log.distance_km)

									mileage.push({
										day: logDate,
										job_name: job_name,
										job_num: job_num,
										job_id: job_id,
										per_diem: per_diem,
										distance: parseFloat(log.distance_km),
										collectiveAgreement: caName,
										collectiveAgreeementId: log_ca_id,
										mileage_pay: log.mileage_pay > 0 ? parseFloat(log.mileage_pay).toFixed(2) : ""
									})
								}
							}
							
						}
					})
				})

				//sort by most recent days first
				payrollLines.sort((a,b) => {

					let momentList = Object.keys(a.days).map(day => vm.moment(day))

					let earliestDayA = vm.moment.min(momentList)

					momentList = Object.keys(b.days).map(day => vm.moment(day))

					let earliestDayB = vm.moment.min(momentList)

					if (earliestDayB.isAfter(earliestDayA))
						return -1

					else
						return 1
				})

				//set color on CAs
				Object.keys(caTotals).forEach(caKey => {
					caTotals[caKey].color = "#424c50"
					vm.unionList.forEach(union => {
						union.CollectiveAgreement.forEach(ca => {
							if (caKey == collectiveAgreements.find(ca2 => ca.id == ca2.id).title && union.text_color != "") {
								caTotals[caKey].color = union.text_color
							}
						})
					})
				})

				user.caTotals = caTotals
				user.dailyTotals = dailyTotals
				user.id = user.id
				user.fullName = user.fullName
				user.totals = user.totals
				user.dailyTotals = dailyTotals
				user.grandTotal = grandTotal
				user.payrollLines= payrollLines
				user.mileage = mileage
				user.totalPerDiemPay = !isNaN(totalPerDiemPay) && totalPerDiemPay > 0 ? totalPerDiemPay.toFixed(2) : ""
				user.totalMileageKm = !isNaN(totalMileageKm) && totalMileageKm > 0 ? totalMileageKm.toFixed(1) : ""
				user.totalMileagePay = !isNaN(totalMileagePay) && totalMileagePay > 0 ? totalMileagePay.toFixed(2) : ""
				//user.collectiveAgreements = user.collectiveAgreements

				return user
			})

			return periodObj.users

		},
		fetchAllUserReports() {
			let vm = this

			let params = {
				filters: [
					['period_id',vm.period.id],
					//["user_id",8]
				]
			}

			vm.spinner(true)

			return new Promise((resolve,reject) => {
				vm.getJSON("PayPeriodUserReport/get",params).then(response => {
					vm.spinner(false)

					if (response.success) {
						vm.payPeriodUserReports = response.data

						response.data.forEach(report => {
							let parsedReport = {}
							try {
								parsedReport = JSON.parse(report.report_json)
							}
							catch (e) {}

							let mutatedReport = vm.mutateReport(parsedReport,report)

							//check that report isn't already pushed
							if (!vm.userReports.find(theReport => theReport.id == mutatedReport.id))
								vm.userReports.push(mutatedReport)

							vm.userNotes[report.user_id] = report.notes

						})
					}

					resolve(response)
				})
			})
		},
		fetchData() {
			let vm = this

			this.spinner(true)

			let promises = [
				this.getJSON("PayPeriod/find/"+this.$route.params.period_slug),
				this.fetchUnions(true),
				this.getJSON("Union/get",{include:["CollectiveAgreement"]}),
				this.getJSON("TimeLogSetting/mine"),
			]

			Promise.all(promises).then(responses => {

				if (responses[0].success)
					vm.period = responses[0].data

				if (responses[1].success) {
					let collectiveAgreements = []
					responses[1].data.forEach(union => {
						if ("CollectiveAgreement" in union && union.CollectiveAgreement.length > 0)
							collectiveAgreements = collectiveAgreements.concat(union.CollectiveAgreement)
					})
					vm.collectiveAgreements = collectiveAgreements
				}

				if (responses[2].success)
					vm.unionList = responses[2].data

				if (responses[3].success)
					vm.$store.timeLogSettings = responses[3].data
	
				/*let entireReport = {}
				try {
					entireReport = JSON.parse(responses[0].data.report_json)
				}
				catch (e){}

				if (Object.keys(entireReport).length > 0 && vm.userReports.length == 0) {
					//OLD REPORT STYLE: entire report exists, render into userReports
					entireReport.users.forEach(userReport => {
						vm.userReports.push(userReport)
					})
				}*/

				let userIdList = []
				try {
					userIdList = JSON.parse(vm.period.user_list_json)
				}
				catch (e) {}

				let params = {
					filters: [
						["id",userIdList]
					],
					fields: ["id","slug","first_name","last_name", "EmployeeSetting"],
					include: [
						{ model: 'EmployeeSetting', fields: ['employee_num'] }
					]
				}

				let userReportParams = {
					filters: [
						["period_id",vm.period.id]
					],
					fields: ["id","user_id","period_id","user_union_ids_json"]
				}

				let secondPromiseSet = [
					vm.getJSON("User/get",params),
					vm.getJSON("PayPeriodUserReport/get",userReportParams)
				]
	
				Promise.all(secondPromiseSet).then(secondResponseSet => {
					vm.users = secondResponseSet[0].data

					vm.briefPayPeriodUserReports = secondResponseSet[1].data

					vm.selectedEmployeeIndex = 1
					vm.setEmployeeIndex(vm.selectedEmployeeIndex)

					vm.spinner(false)
				})
				
			})
		}
	},
	created() {
		this.fetchData()

		if (this.$route.path.indexOf("detailed") >= 0) {
			this.totalsPage = false
			this.tabActiveIndex = 0
		}
		else if (this.$route.path.indexOf("summary") >= 0) {
			this.totalsPage = true
			this.tabActiveIndex = 1
		}
	}

}
</script>

<style type="text/css" scoped>
	
	.table h3, .table h4 {
		margin: 0;
		text-decoration: none;
	}

	.user-heading {
		background-color: #CFD8DC;
	}

	.hours-heading {
		background-color: #EFEBE9;
	}

	.mileage-heading {
		background-color: #E0F2F1;
	}

	@media print {
		.print-mode-button {
			display: none;
		}

		button {
			display: none!important;
		}

		a {
			color: black!important;
		}
	}
</style>
